export const MENU_STATUS = "MENU_STATUS";
export const ACTIVE_MENU = "ACTIVE_MENU";

// Menu Data
export const PRODUCTS_UPDATED = "PRODUCTS_UPDATED";
export const BUNDLES_UPDATED = "BUNDLES_UPDATED";
export const CAMPAIGN_UPDATED = "CAMPAIGN_UPDATED";
export const TRAININGS_UPDATED = "TRAININGS_UPDATED";
export const APPS_UPDATED = "APPS_UPDATED";
